import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import { useSelector } from 'react-redux';
import DetailProduct from './DetailProduct';
import DrinksScreens from './drinks';
import HotDrinksScreen from './hotDrink';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [carnte, setcarnte] = useState(false);
    const [dataDrink, setdataDrink] = useState(false);
    const [showDrinks, setshowDrinks] = useState(false);
    const [showPicadera, setshowPicadera] = useState(false);
    const [showMofongos, setshowMofongos] = useState(false);
    const [showMariscos, setshowMariscos] = useState(false);
    const [showCarnes, setshowCarnes] = useState(false);
    const [showEntradas, setshowEntradas] = useState(false);
    const [showEnsaladas, setshowEnsaladas] = useState(false);
    const [showDesayunos, setshowDesayunos] = useState(false);
    const [showChofan, setshowChofan] = useState(false);
    const [showCocteles, setshowCocteles] = useState(false);
    const [showSandwiches, setshowSandwiches] = useState(false);
    const [showAcompanantes, setshowAcompanantes] = useState(false);
    const [showCombos, setshowCombos] = useState(false);
    const [showCafe, setshowCafe] = useState(false);
    const [showBatidos, setshowBatidos] = useState(false);
    const [showJugos, setshowJugos] = useState(false);
    const [showPostres, setshowPostres] = useState(false);
    const [showSopas, setshowSopas] = useState(false);
    const [showPastas, setshowPastas] = useState(false);
    const [showHotDrinks, setshowHotDrinks] = useState(false);




     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
                if (item.id === 479) {
                    setdrinks(item);
                    
                }
               
                 if (item.id === 469) {
                    setcarnte(item);
                 }
                
                if(item.id === 858) {
                    setshowPicadera(item);
                }
                if(item.id === 859) {
                    setshowMofongos(item);
                }
                if(item.id === 860) {
                    setshowMariscos(item);
                }
                if(item.id === 836) {
                    setshowCarnes(item);
                }
                if(item.id === 861) {
                    setshowEntradas(item);
                }
                if(item.id === 862) {
                    setshowEnsaladas(item);
                }
                if(item.id === 863) {
                    setshowDesayunos(item);
                }
                if(item.id === 844) {
                    setshowChofan(item);
                }
                if(item.id === 866) {
                    setshowCocteles(item);
                }
                if(item.id === 864) {
                    setshowSandwiches(item);
                }
                if(item.id === 865) {
                    setshowAcompanantes(item);
                }
                
                if(item.id === 868) {
                    setshowCombos(item);
                }
                if(item.id === 867) {
                    setshowCafe(item);
                }
                if(item.id === 851) {
                    setshowBatidos(item);
                }
                if(item.id === 851) {
                    setshowJugos(item);
                }
                if(item.id === 850) {
                    setshowPostres(item);
                }
                if(item.id === 866) {
                    setshowSopas(item);
                }
                if(item.id === 869) {
                    setshowPastas(item);
                }
            });
      }, [menus]);
    
    
    
     useEffect(() => {
         if (drinks) {
             drinks.menus.map((item) => {
                 if (item.id === 4374) {
                     setdataDrink(item)
                     
                
               }
           })
       }
     }, [drinks]);
    
    
    useEffect(() => {
        console.log(goHomeInit, 'q mas qlq')
         setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
        setshowCategories(false)
        setShowDetailProduct(false)
        setshowHotDrinks(false)
    }, [goHomeInit]);
    


    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            setshowHotDrinks(false)
            getInitData();

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    

    return (
         <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false} showImageTop={true} setShowSpecials={() => {
            setShowSpecials(true)
            }} goCategories={() => {
                setShowListProduct(true)
                setdishs(showCocteles)
        }}>
                <div>
                    
                    <img
                        style={{
                            width: 490,
                            height: 120,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            position: 'relative',
                            marginTop: -15,
                            marginBottom: -40,
                            
                        }}
                        src={require('./assets/logo.png')}
                    />


                    <div style={{display: 'flex', flexDirection: 'row', gap: 0, paddingInline:0}}>
                        <img
                            style={{
                                width: '50%',
                                height: 200,
                                justifyContent: 'center',
                                objectFit: 'contain',
                                zIndex: 100,
                                alignSelf: 'center',
                                position: 'relative',
                                marginTop: 40,
                                
                            }}
                            src={require('./assets/delivery.jpg')}
                        />

                        <video
                            onClick={() => {
                                setShowListProduct(true)
                                    setdishs(showMofongos)
                               
                            }}
                            autoPlay
                            loop
                            muted
                            playsInline
                            style={{
                                width: '50%',
                                height: 200,
                                justifyContent: 'center',
                                objectFit: 'contain',
                                zIndex: 100,
                                alignSelf: 'center',
                                position: 'relative',
                                marginTop: 40,
                                
                            }}
                            src={require('./assets/entradas.mp4')}
                        />
                    </div>
                   
                    <div
                        style={{
                            width: '100%',
                            margin: '14px auto 0',
                            display: 'flex',
                            flexDirection: 'column',
                            
                            position: 'relative',
                            zIndex: 100,
                            paddingInline: 2
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 1, marginBottom: 10 }}>
                            <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showMofongos)
                                }}
                                src={require('./assets/rowone/PAPICAR.png')} style={{ width: '29%', objectFit: 'contain', cursor: 'pointer' }} />
                             <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showMariscos)
                                }}
                                src={require('./assets/rowone/CARNE.png')} style={{ width: '29%', objectFit: 'contain', cursor: 'pointer' }} />
                            
                             
                            <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showDesayunos)
                                }}
                                src={require('./assets/rowone/MARISCOS.png')} style={{ width: '29%', objectFit: 'contain', cursor: 'pointer' }} />
                            
                           
                        </div>
                        
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                            <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showEntradas)
                                }}
                                src={require('./assets/rowone/POLLO.png')} style={{ width: '29%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showEnsaladas)
                                }}
                                src={require('./assets/rowone/CERDO.png')} style={{ width: '29%', objectFit: 'contain', cursor: 'pointer' }} />
                            
                           <img
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(showSandwiches)
                            }}
                            src={require('./assets/rowone/COMIDARAPIDA.png')} style={{ width: '29%', objectFit: 'contain', cursor: 'pointer' }} />
                            
                            
                            
                            
                        </div>
                    </div>

                   
                </div>
                 <div
                        style={{
                            width: '100%',
                            margin: '10px auto 0',
                            display: 'flex',
                            flexDirection: 'column',
                           
                            position: 'relative',
                        zIndex: 100,
                            paddingInline: 2
                        }}
                >
                    <div style={{ display: 'flex', justifyContent: 'center', gap: 0, marginBottom: 10 }}>
                       
                       {/* <img
                                onClick={() => {
                                    setShowListProduct(true)
                                    setdishs(showPicadera)
                                }}
                                src={require('./assets/rowone/DESAYUNO.png')} style={{ width: '29%', objectFit: 'contain', cursor: 'pointer' }} /> */}
                        <img
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(showAcompanantes)
                            }}
                            src={require('./assets/rowone/PARANINOS.png')} style={{ width: '29%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(showCombos)
                            }}
                            src={require('./assets/rowone/ACOMPANANTES.png')} style={{ width: '29%', objectFit: 'contain', cursor: 'pointer' }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 0}}>
                        <img
                            onClick={() => {
                                setshowHotDrinks(true)
                            }}
                            src={require('./assets/rowone/BEBIDASCALIENTES.png')} style={{ width: '30%', height: 75, marginLeft: -4,objectFit: 'contain', cursor: 'pointer' }} />
                        <img
                            onClick={() => {
                                setShowListProduct(true)
                                setdishs(showSopas)
                            }}
                            src={require('./assets/rowone/BEBIDASFRIAS.png')} style={{ width: '30%', height: 75,marginLeft: 0,objectFit: 'contain', cursor: 'pointer' }} />
                        <img
                            onClick={() => {
                                setShowListProduct(true)
                               setdishs(showPastas)
                            }}
                            src={require('./assets/rowone/POSTRES.png')} style={{ width: '30%', height: 75, marginRight: -5,objectFit: 'contain', cursor: 'pointer' }} />
                       
                    </div>
                </div>
                
                <div style={{ width: '100%', position: 'relative'}}>
                     <img
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{
                        width: '100%',
                        height: 212,
                            borderRadius: 14,
                            objectFit: 'contain',
                            marginTop: -23
                            
                       
                        }}
                        src={require('./assets/BANNER.png')}
                    />
                    
                </div>

                

           
            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
                />}
            {showHotDrinks && <HotDrinksScreen  dishs={dishs}
                setShowListProduct={setshowHotDrinks}/>}

            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
                {showBar && <BarScreen setShowBar={setShowBar} />}
                   {showDrinks && <DrinksScreens setShowListProduct={setshowDrinks} setShowHappy={setshowCategories} />}
            

            {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
            />}
            
           
      
            
        </LayoutContent>
        </div>
    );
}

export default Index;